import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Update canonical URL dynamically for the current route
    let canonical = document.querySelector("link[rel='canonical']");
    const cleanPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
    const canonicalHref = `https://chikinlady.com${cleanPath}`;

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);
  }, [pathname]);

  return null;
}
